import { render, staticRenderFns } from "./vc-async-component.vue?vue&type=template&id=785104ca&scoped=true&"
import script from "./vc-async-component.vue?vue&type=script&lang=js&"
export * from "./vc-async-component.vue?vue&type=script&lang=js&"
import style0 from "./vc-async-component.vue?vue&type=style&index=0&id=785104ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785104ca",
  null
  
)

export default component.exports